import Vue from 'vue'
import App from './App.vue'
import SocialSharing from 'vue-social-sharing'
import router from './router'

Vue.use(SocialSharing)

Vue.config.productionTip = false

/* eslint-disable-next-line no-new */
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
